// Ultimate Card Game (UCG) / VOID Card Warfare - readable accent for the player's HP bar colour
//
// The equipped HP bar colour (js/engine/slotMachine.js REEL_3_STYLES, 'hp_bar_color') also colours
// two outline buttons on a near-black face: the Cargo Bay button of the game-over modal and the
// Bridge tile in the match HUD (text, border and glow, see .game-over-btn-bridge and
// #btn-quick-bridge in css/main.css). Obsidian Black (#0F172A) is practically the colour of that
// face, so label and border vanished (black on black).
//
// resolveHpBarAccent() is the front-end exception: when the chosen colour would be hard to read on
// that face it returns Chrome Silver instead. Filled buttons (.btn-packs) are unaffected, they have
// their own contrast text colour (--player-hp-bar-text-color in js/main.js).

// Chrome Silver of the same palette (REEL_3_STYLES 'chrome_silver').
export const HP_ACCENT_SILVER = '#E2E8F0';
export const HP_ACCENT_SILVER_GLOW = 'rgba(226, 232, 240, 0.55)';

// Average of the button face gradient (rgba(16,28,44) -> rgba(8,16,26)) and the dark HUD behind it.
const BUTTON_FACE_LUMINANCE = relativeLuminance('#0c1622');

// WCAG "large / UI component" minimum. Below it a border or bold label is hard to make out.
export const MIN_ACCENT_CONTRAST = 3;

function channel(v) {
  const c = v / 255;
  return c <= 0.03928 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4);
}

export function parseHex(hex) {
  const h = String(hex || '').trim().replace(/^#/, '');
  const full = h.length === 3 ? h.split('').map((c) => c + c).join('') : h;
  if (!/^[0-9a-fA-F]{6}$/.test(full)) return null;
  return [parseInt(full.slice(0, 2), 16), parseInt(full.slice(2, 4), 16), parseInt(full.slice(4, 6), 16)];
}

export function relativeLuminance(hex) {
  const rgb = parseHex(hex);
  if (!rgb) return 0;
  return 0.2126 * channel(rgb[0]) + 0.7152 * channel(rgb[1]) + 0.0722 * channel(rgb[2]);
}

// WCAG contrast ratio of a colour against the button face (1 = identical, 21 = black on white).
export function contrastOnButtonFace(hex) {
  const l = relativeLuminance(hex);
  const hi = Math.max(l, BUTTON_FACE_LUMINANCE);
  const lo = Math.min(l, BUTTON_FACE_LUMINANCE);
  return (hi + 0.05) / (lo + 0.05);
}

// color / glow are the values for --player-hp-bar-accent / --player-hp-bar-accent-glow.
// `glow` is the glow the unmodified colour would use (what the HP bar itself uses).
export function resolveHpBarAccent(hex, glow) {
  if (parseHex(hex) && contrastOnButtonFace(hex) < MIN_ACCENT_CONTRAST) {
    return { color: HP_ACCENT_SILVER, glow: HP_ACCENT_SILVER_GLOW, adjusted: true };
  }
  return { color: hex, glow, adjusted: false };
}
